/* @flow */

import { schema } from 'normalizr';

export const courseContentSchema = new schema.Entity('courseContents', {}, { idAttribute: 'uid' });
export const courseSchema = new schema.Entity(
  'courses',
  {
    courseContents: [courseContentSchema],
  },
  { idAttribute: 'uid' }
);
export const contestSchema = new schema.Entity(
  'contests',
  {
    courses: [courseSchema],
  },
  { idAttribute: 'uid' }
);
